/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1SerievideoSeriesSerieidMutationRequest,
  PostApiV1SerievideoSeriesSerieidMutationResponse,
  PostApiV1SerievideoSeriesSerieidPathParams,
  PostApiV1SerievideoSeriesSerieid400,
  PostApiV1SerievideoSeriesSerieid401,
  PostApiV1SerievideoSeriesSerieid404,
  PostApiV1SerievideoSeriesSerieid500,
} from "../../types/serieVideoRegistroController/PostApiV1SerievideoSeriesSerieid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1SerievideoSeriesSerieid } from "../../clients/serieVideoRegistroController/postApiV1SerievideoSeriesSerieid.ts";

export const postApiV1SerievideoSeriesSerieidMutationKey = () =>
  [{ url: "/api/v1/serievideo/series/:serieId" }] as const;

export type PostApiV1SerievideoSeriesSerieidMutationKey = ReturnType<
  typeof postApiV1SerievideoSeriesSerieidMutationKey
>;

export function postApiV1SerievideoSeriesSerieidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1SerievideoSeriesSerieidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1SerievideoSeriesSerieidMutationKey();
  return mutationOptions<
    PostApiV1SerievideoSeriesSerieidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoSeriesSerieid400
      | PostApiV1SerievideoSeriesSerieid401
      | PostApiV1SerievideoSeriesSerieid404
      | PostApiV1SerievideoSeriesSerieid500
    >,
    {
      serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"];
      data?: PostApiV1SerievideoSeriesSerieidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ serieId, data }) => {
      return postApiV1SerievideoSeriesSerieid(serieId, data, config);
    },
  });
}

/**
 * @description Cria um vídeo na série informada na rota (serieId), via multipart/form-data, com título/resumo/embed no idioma corrente e imagem de capa opcional. **(Requer Authorization para autenticação)**
 * @summary Criar vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/series/:serieId}
 */
export function usePostApiV1SerievideoSeriesSerieid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1SerievideoSeriesSerieidMutationResponse,
      ResponseErrorConfig<
        | PostApiV1SerievideoSeriesSerieid400
        | PostApiV1SerievideoSeriesSerieid401
        | PostApiV1SerievideoSeriesSerieid404
        | PostApiV1SerievideoSeriesSerieid500
      >,
      {
        serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"];
        data?: PostApiV1SerievideoSeriesSerieidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1SerievideoSeriesSerieidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1SerievideoSeriesSerieidMutationKey();

  const baseOptions = postApiV1SerievideoSeriesSerieidMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1SerievideoSeriesSerieidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoSeriesSerieid400
      | PostApiV1SerievideoSeriesSerieid401
      | PostApiV1SerievideoSeriesSerieid404
      | PostApiV1SerievideoSeriesSerieid500
    >,
    {
      serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"];
      data?: PostApiV1SerievideoSeriesSerieidMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1SerievideoSeriesSerieidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoSeriesSerieid400
      | PostApiV1SerievideoSeriesSerieid401
      | PostApiV1SerievideoSeriesSerieid404
      | PostApiV1SerievideoSeriesSerieid500
    >,
    {
      serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"];
      data?: PostApiV1SerievideoSeriesSerieidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1SerievideoSeriesSerieidMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoSeriesSerieid400
      | PostApiV1SerievideoSeriesSerieid401
      | PostApiV1SerievideoSeriesSerieid404
      | PostApiV1SerievideoSeriesSerieid500
    >,
    {
      serieId: PostApiV1SerievideoSeriesSerieidPathParams["serieId"];
      data?: PostApiV1SerievideoSeriesSerieidMutationRequest;
    },
    TContext
  >;
}
